import { useTimezoneWarning } from 'ts-components/TimezoneWarning';
import styled from '@emotion/styled';
import { TimezoneWarning } from '__components/Inputs/DateTimeInput/TimezoneWarning';
import { FC, ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const StyledTimezoneWarning = styled(TimezoneWarning)`
  position: static;
  align-items: center;
  margin-top: 8px;
`;

export const DateTimeTimezoneWarning: FC<{
  dateValue: string;
  className?: string;
  render?: (
    props: ReturnType<typeof useTimezoneWarning>
  ) => ReactElement | null;
}> = ({ dateValue, className, render }) => {
  const { t } = useTranslation();

  const date = useMemo(() => new Date(dateValue), [dateValue]);

  const timezoneProps = useTimezoneWarning(date);

  const {
    isBusinessTimeMatchesLocal,
    businessTimezone,
    businessTimeZoneString,
    businessDateString,
  } = timezoneProps;

  if (isBusinessTimeMatchesLocal) {
    return null;
  }

  return (
    <StyledTimezoneWarning className={className}>
      {typeof render === 'function'
        ? render(timezoneProps)
        : t(
            'Your timezone differs from the business timezone. This will be set to {{businessDateString}} in the business timezone ({{business}}).',
            {
              business: `${businessTimezone} ${businessTimeZoneString}`,
              businessDateString,
            }
          )}
    </StyledTimezoneWarning>
  );
};
